module.exports = __webpack_public_path__ + "static/media/vortex-logo.831b5e25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vortex-logo.svg
// module id = 304
// module chunks = 0